import {
  APP_SETTING_LOAD_PAGE_DETAILS_BEGIN,
  APP_SETTING_LOAD_PAGE_DETAILS_SUCCESS,
  APP_SETTING_LOAD_PAGE_DETAILS_FAILURE,
  APP_SETTING_LOAD_PAGE_DETAILS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPageDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PAGE_DETAILS_BEGIN,
    });

    const { projectId, version, pageId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_PAGE_DETAILS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PAGE_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissloadPageDetailsError() {
  return {
    type: APP_SETTING_LOAD_PAGE_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PAGE_DETAILS_BEGIN:
      return {
        ...state,
        loadPageDetailsPending: true,
        loadPageDetailsError: null,
      };

    case APP_SETTING_LOAD_PAGE_DETAILS_SUCCESS:
      return {
        ...state,
        loadPageDetailsPending: false,
        loadPageDetailsError: null,
        pageDetails: action.data,
      };

    case APP_SETTING_LOAD_PAGE_DETAILS_FAILURE:
      return {
        ...state,
        loadPageDetailsPending: false,
        loadPageDetailsError: action.data.error,
      };

    case APP_SETTING_LOAD_PAGE_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        loadPageDetailsError: null,
      };

    default:
      return state;
  }
}
